<script lang="ts">
	import type { Style } from '$lib/types';
	import { Doc } from 'sveltefire';

	export let style: Style;
</script>

<div
	class="flex-start flex h-20 w-full items-center justify-start gap-4 rounded-lg p-2 text-left font-normal hover:bg-base-200">
	<div class="w-12 flex-none">
		<Doc ref="images/{style.image}" let:data={c}>
			<img src={c.src} alt={style.title} class="h-12 w-12 rounded-full" />
		</Doc>
	</div>
	<div class="flex-grow">
		<div class="flex justify-between">
			<span class="font-story text-lg">{style.title}</span>
		</div>
	</div>
</div>
